module.exports = "<sc-query-builder-node node=\"{group: $ctrl.group}\" is-root=\"true\"></sc-query-builder-node>"


//////////////////
// WEBPACK FOOTER
// ./src/filter/query-builder/query-builder.component.html
// module id = 298
// module chunks = 0